import { makeStyles } from "@material-ui/core";

const plainDesign = makeStyles({
    root: {
        background: "linear-gradient(130deg, #29b6f6 0%, #29b6f6 11%, #29b6f6 40%, #53c4f7 100%)",
        color: "white"
    }
})

export default plainDesign